import styled, {keyframes} from 'styled-components';

const spinner = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const StyledLoader = styled.div`
    display: inline-block;
    position: relative;
    width: 50px;
    height: 50px;
`;

const LoadPart = styled.div`
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 40px;
    height: 40px;
    margin: 4px;
    border: 6px solid var(--color-green);
    border-radius: 50%;
    animation: ${spinner} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: var(--color-green) transparent transparent transparent;
    
    &:nth-child(1) {
        animation-delay: -0.45s;
    }

    &:nth-child(2) {
        animation-delay: -0.3s;
    }

    &:nth-child(3) {
        animation-delay: -0.15s;
    }
`;

export const Spinner = ({ ...props }) => {

    return (
        <StyledLoader {...props}>
            <LoadPart />
            <LoadPart />
            <LoadPart />
            <LoadPart />
        </StyledLoader>
    );
}